var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ig"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse 24",
    cx: 11.6849,
    cy: 11.4349,
    r: 10.72,
    stroke: "#EFEFF0",
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon ionic-logo-instagram"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2948",
    d: "M13.8984 7.73049C14.3953 7.73049 14.8664 7.92737 15.2227 8.28128C15.579 8.6352 15.7735 9.10865 15.7735 9.60553V13.3556C15.7735 13.8525 15.5766 14.3236 15.2227 14.6799C14.8688 15.0361 14.3953 15.2307 13.8984 15.2307H10.1481C9.65123 15.2307 9.1801 15.0338 8.82382 14.6799C8.46755 14.326 8.273 13.8525 8.273 13.3556V9.60553C8.273 9.10865 8.46989 8.63754 8.82382 8.28128C9.17775 7.92502 9.65123 7.73049 10.1481 7.73049H13.8984ZM13.8984 6.98047H10.1481C8.70428 6.98047 7.52295 8.16175 7.52295 9.60553V13.3556C7.52295 14.7994 8.70428 15.9807 10.1481 15.9807H13.8984C15.3423 15.9807 16.5236 14.7994 16.5236 13.3556V9.60553C16.5236 8.16175 15.3423 6.98047 13.8984 6.98047Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2949",
    d: "M14.461 9.6055C14.1492 9.6055 13.8984 9.35471 13.8984 9.04298C13.8984 8.73126 14.1492 8.48047 14.461 8.48047C14.7704 8.48047 15.0235 8.73126 15.0235 9.04298C15.0235 9.35471 14.7704 9.6055 14.461 9.6055Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado 2950",
    d: "M12.0234 9.98049C12.8508 9.98049 13.5235 10.6532 13.5235 11.4805C13.5235 12.3079 12.8508 12.9806 12.0234 12.9806C11.196 12.9806 10.5232 12.3079 10.5232 11.4805C10.5232 10.6532 11.196 9.98049 12.0234 9.98049ZM12.0234 9.23047C10.7811 9.23047 9.77319 10.2383 9.77319 11.4805C9.77319 12.7227 10.7811 13.7306 12.0234 13.7306C13.2656 13.7306 14.2735 12.7227 14.2735 11.4805C14.2735 10.2383 13.2656 9.23047 12.0234 9.23047Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIg);
export default __webpack_public_path__ + "static/media/ig.c4a0d27d7928669fd418174471f6541c.svg";
export { ForwardRef as ReactComponent };